export class ProductSearchFilter {

  constructor(
    public productType?: string,
    public tenor?: string,
    public currency?: string,
    public searchTerm?: string,
    public from?: string,
    public to?: string
    ) {
  }

  toFilterParams(): ProductSearchFilter {
    return Object.keys(this).reduce((acc, key) => {
      if (this[key]?.trim().length) {
        acc[key] = this[key];
      }
      return acc;
    }, {} as ProductSearchFilter);
  }

}
